var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddCForm',{attrs:{"payload":{'is_root':true}},on:{"form-submit":_vm.sendData,"form-cancel":_vm.goBack}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.err),expression:"err"}]},[_vm._v(_vm._s(_vm.err))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }